export default __webpack_public_path__ + "static/media/e-sport-1.d0c6dc1a.png";